import { render, staticRenderFns } from "./ColorList.vue?vue&type=template&id=489aa4be&"
import script from "./ColorList.vue?vue&type=script&lang=js&"
export * from "./ColorList.vue?vue&type=script&lang=js&"
import style0 from "./ColorList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports